// ############################ Require packages here ############################
import React, { lazy, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Aos from 'aos';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// ############################ Require files here ###############################

import ScheduleForm from '../scheduleForm';
// import TestimonialSlider from '../testimonialSlider';
import RelatedResources from '../relatedResources';
import { getOneResource } from '../../../Redux/ActionCreators/resourcesAction';
const TestimonialSlider = lazy(() => import("../testimonialSlider"));



const risks = [
    { image: '/images/folderopen.svg', title: 'Data Breach and IP Theft', description: 'A pharma cyberattack can expose pharma IT and data assets to threat actors, leading to reputational and financial losses.' },
    { image: '/images/shieldsecurity.svg', title: 'Ransomware Risk', description: 'Pharma cyberattacks in the form of ransomware exfiltrate and encrypt critical data, disrupt operations, and cause control loss.' },
    { image: '/images/fostering.svg', title: 'Compliance Regulations', description: 'Mandatory compliance with all regulations like HIPAA, GLP, HITRUST, Compliance Monitoring Authority, and DST is complex and demanding.' },
    { image: '/images/shield-exclamation.svg', title: 'Expanding Attack Surface', description: `The proliferation of IT, OT, and Internet of Things (IoT) devices creates a larger attack surface and exposes new vulnerabilities.` },
    { image: '/images/person.svg', title: 'Insider Threat', description: 'Insiders, contractors and ecosystem users with legitimate access can abuse their privileges, steal data, sabotage systems, or introduce malware.' },
    { image: '/images/broken-chain-link-wrong.svg', title: 'Supply Chain Vulnerabilities', description: 'Reliance on third-party supply chains introduces weaknesses that attackers can exploit to access pharma assets.' },
    { image: '/images/mask.svg', title: 'Social Engineering Attacks', description: `Employees lacking cybersecurity awareness make their organizations vulnerable to attacks like phishing and other such attacks.` },
    { image: '/images/brake-warning.svg', title: 'Cyber Sabotage', description: `Persistent attackers apply AI-based reconnaissance and infiltrate systems, disrupting logistics and operations.` },
    { image: '/images/queue.svg', title: 'Unaware Workforce', description: `Companies with under-trained, unaware, or overly curious employees are vulnerable to exploitation by cyber adversaries.` },
]

const helpList = [{ image: '/images/pulse.svg', title: 'Enhanced Security Monitoring', description: `Sequretek's Percept Continuous Threat Exposure Management (CTEM) continuously monitors IT infrastructure for threats and mitigates potential breaches.` },
{ image: '/images/shield.svg', title: 'Threat Detection and Response', description: 'Advanced cyber risk management with our EDR, XDR & NG SIEM, SOAR products and services help monitor, detect, and respond to cyberattacks in real-time. ' },
{ image: '/images/alert.svg', title: 'User Access Management', description: 'Our identity products and services prevent data breaches by continuously monitoring user activity and limiting access to authorized personnel only.' },
{ image: '/images/user-key.svg', title: 'Conformance to Compliance Mandates', description: ` Our governance and compliance reports help comply with HIPAA, HITRUST, FDA guidelines, SEC, CERT-In and other regulations.` },
{ image: '/images/house-lock.svg', title: 'Vulnerability Management', description: 'Sequretek strengthens defenses, fixes vulnerabilities, and ensures system stability with regular audits, patching, and critical infrastructure update deployment.' },
{ image: '/images/customer-care-white.svg', title: 'Managed Security Services', description: `Sequretek MSS offers 24/7 onsite/remote services, including audit and advisory, risk and governance, incident response, server, network and perimeter security.` },
]



export default function Spotlight2() {

    useEffect(() => {
        Aos.init({ duration: 2000 })
    }, [])


    const navigate = useNavigate();
    const dispatch = useDispatch();

    const setPage = (val) => {
        window.scrollTo(0, 0);
        if (val === 'contact') {
            window.scrollTo(0, 2500);
        } else if (val === 'resources') {
            navigate('/resources-hub')
        }
    }

    const downloadFactsheet = async () => {
        const res = await dispatch(getOneResource(['6874f17073e7c96684556880']))
        if (res?.type === 'GET_ONE_RESOURCES') {
            navigate(`/resources/case-study/${encodeURIComponent(res.payload?.title)}`, { state: { data: res?.payload } })
        }
    }


    return (
        <div className='seq-content-page'>
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <meta charSet="utf-8" />
                <title>Underwriting Trust: Cybersecurity’s Role in Modern Insurance</title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
                <meta name="description" content="Safeguard your pharmaceutical assets from cyber threats. Mitigate risks, ensure compliance, and build trust with robust cybersecurity." />
                <meta name="keywords" content="Pharma Cyber Attack, Pharma Cyber security, Supplychain, FDA Guidelines" />
                <meta property="og:title" content="Pharma Cyber Resilience: Building a Secure Future Together" />
                <meta property="og:description" content="Safeguard your pharmaceutical assets from cyber threats. Mitigate risks, ensure compliance, and build trust with robust cybersecurity." />
            </Helmet>
            {/* section 1 BANNER */}
            <div className='seq-content-heading' style={{ backgroundImage: `url('/images/Qut2 Hero Banner.svg')` }}>
                <div className='seq-description'>
                    <h2 data-aos="fade-up">
                        <p style={{ fontSize: "36px", color: " #A2DAE0" }}>The Qut - Episode 2</p>
                        Underwriting Trust: Cybersecurity’s Role in Modern Insurance
                    </h2>
                    <div data-aos="fade-up" className='text-center mt-3'>
                        <button onClick={() => downloadFactsheet()} class="ext-btn">Download Case Study</button>
                        <button onClick={() =>
                            window.open(
                                "https://www.youtube.com/playlist?list=PLAF1rJ3_wb2t0-5QMKm2tDNWSjnjo6fQz",
                                "_blank",
                                "noopener,noreferrer"
                            )
                        } >Take a Peek</button>
                    </div>
                </div>
            </div>
            {/* section 2 INFO */}
            <div className='seq-content-1'>
                <div className='container pe-0'>
                    <div className='row me-0'>
                        <div className='col-md-5 col-sm-12 col-12'>
                            <h4>
                                <img src='/images/Qut2 - Insurance Icon.svg' alt='' height={60} loading="lazy" />
                                <br />   <br />
                                So how can insurers turn regulatory pressure into competitive strength?
                            </h4>
                        </div>
                        <div className='col-md-6 col-sm-12 offset-lg-1 col-12 seq-info-text'>
                            <p>The insurance industry runs on trust, every policy, every claim, every interaction depends on it. But as insurers modernize with digital platforms, AI underwriting, and third-party integrations, that very trust is under siege. Cyberattacks on the BFSI sector are rising fast, and IRDAI’s evolving cyber resilience framework signals one thing - compliance is no longer just about meeting regulations; it’s about surviving disruption.</p>
                            <p>That’s why we brought together two trusted voices for a conversation that cut through the noise.</p>
                            <p>The Qut with Kiran Belsekar – Executive Vice President, Bandhan Life, and Pankit Desai, CEO & Co-Founder, Sequretek</p>
                            </div>
                    </div>
                </div>
            </div>
            {/* section 3 CHALLENGES */}
            <div className="seq-content-1">
                <div className="container pe-0">
                    <div className="row me-0 justify-content-center">

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/sp-Compliance.svg" alt="Compliance" height={40} />
                            <h4>Compliance</h4>
                            <p style={{ textAlign: "center" }}>
                                Decode IRDAI’s mandates to turn adherence into assurance and align cybersecurity with governance and customer trust
                            </p>
                        </div>

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/sp-Risk.svg" alt="Risk" height={40} />
                            <h4>Risk</h4>
                            <p style={{ textAlign: "center" }}>
                                Understand how insurers can proactively manage digital, third-party, and supply-chain threats before they impact operations
                            </p>
                        </div>

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/sp-Continuity.svg" alt="Continuity" height={40} />
                            <h4>Continuity</h4>
                            <p style={{ textAlign: "center" }}>
                                Build resilience that doesn’t just protect systems but ensures policyholder confidence and uninterrupted business operations
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* section 6 */}
            <div className='seq-how-to-helps' style={{ backgroundImage: `url('/images/spotlight_para.svg')`, backgroundSize: "cover" }}>
                <div className='container'>
                    <div className='seq-help-bg'>
                        <div className='row '>
                            <div data-aos="fade-up" className=' col-md-5 col-12 seq-help-left'>
                                <p>How Sequretek Helps</p>
                                <h3>Unlock Peace of Mind with Sequretek’s Tailored Cyber Solutions</h3>
                                <button onClick={() => setPage('contact')}>Get started</button>
                            </div>
                            {window.innerWidth > 767 ?
                                <div className='col-md-4  offset-md-1 seq-ind-qimg'>
                                    <img src='/images/q-icon1.svg' alt='' height={300} loading="lazy" />
                                </div> :
                                null
                            }
                        </div>
                    </div>

                </div>
            </div>
            {/* section 5 */}
            <div className='seq-content-1'>
                <div className='container pe-0'>
                    <div className='row me-0'>
                        <div className='col-md-5 col-sm-12 col-12'>
                            <img src='/images/The Qut - 2.png' style={{ width: "500px !important;" }} alt='' loading="lazy" />
                        </div>
                        <div className='col-md-6 col-sm-12 offset-lg-1 col-12 seq-info-text'>
                            <h4>Plainspeak Drives Real Action</h4><br />
                            <p>The Qut is our platform to spotlight critical conversations with leaders solving real security challenges. No fluff, just insight. </p>
                            <p style={{ marginTop: "15px" }}>This executive exchange aims to help you rethink your cybersecurity posture and leadership approach in an increasingly digitized automotive industry.</p>
                            <button onClick={() =>
                                window.open(
                                    "https://www.youtube.com/playlist?list=PLAF1rJ3_wb2t0-5QMKm2tDNWSjnjo6fQz",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            } className='reserve-btn'>Take a Peek</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* section 7 SCHEDULE DEMO FORM */}
            <div className='seq-forms'>
                <div className='container ps-4 pe-4 '>
                    <div className='col-md-12 col-sm-12 col-12  seq-info-text'>
                        <h4 className='heading_k'>How can we help improve your security posture? Let’s talk!</h4>
                    </div>
                    <div className="insurance-partseven" data-aos="fade-up">
                        <ScheduleForm
                            text={'The security of your data and infrastructure is more critical than ever. Secure your sensitive data with Sequretek’s enhanced security monitoring and threat detection and ensure that your critical information remains confidential and protected.'}
                            bg={'/images/bg-img74.svg'}
                            mobilebg={'/images/bg-img71.svg'}
                            page='banking'
                        />
                    </div>
                </div>
            </div>
            {/* section 7 RELATED RESOURCES */}
            <div className='seq-resources'>
                <div className='container'>
                    <h4>Related resources</h4>
                    <div className='row ms-0 me-0'>
                        <div className='col-md-12 ps-0'>
                            <div className={window.innerWidth > 767 ? 'row ' : 'row flex-nowrap overflow-auto'}>
                                <RelatedResources
                                    page='spotlight2'
                                    type=''
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {window.innerWidth > 767 ? <div className='d-flex align-items-center justify-content-center' style={{ background: '#040c30' }}><button className='seq-resource-btn' onClick={() => setPage('resources')}>Visit the resource center</button></div> : <div className='d-flex align-items-center justify-content-center' style={{ background: '#040c30' }}><button className='seq-resource-btn' onClick={() => setPage('resources')}>Resource Center</button></div>}
        </div>
    )
}
